import React from "react";
import {Route, Routes} from "react-router-dom";
import Home from "../pages/Home";
import NotFound from "../pages/NotFound";
import ContactUsPage from "../pages/ContactUsPage";
import PartnersPage from "../pages/PartnersPage";
import AboutUsPage from "../pages/AboutUsPage";
import LoginPage from "../pages/LoginPage";
import BranchesPage from "../pages/BranchesPage";
import ServicesPage from "../pages/ServicesPage";
import TrackingPage from "../pages/TrackingPage";
import TermsAndConditionPage from "../pages/TermsAndConditionPage";
import ShippingAgreementPage from "../pages/ShippingAgreementPage";
import BookingPage from "../pages/BookingPage";


const AppRoutes = () => {
    return (
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/tracking/:code" element={<TrackingPage />} />
                <Route path="/terms-conditions" element={<TermsAndConditionPage />} />
                <Route path="/shipping-agreement" element={<ShippingAgreementPage />} />
                <Route path="/about" element={<AboutUsPage />} />
                <Route path="/partners" element={<PartnersPage />} />
                <Route path="/services" element={<ServicesPage />} />
                <Route path="/contactus" element={<ContactUsPage />} />
                <Route path="/branches" element={<BranchesPage />} />
                <Route path="/booking" element={<BookingPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="*" element={<NotFound />} />
            </Routes>
    );
};

export default AppRoutes;
